import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import IndividualSalesReportAPI from "../../../api/IndividualSalesReportAPI";
import ChartComponent from "../FixedReportChart";

class IndividualMeetingByProject extends React.Component {
  constructor(props) {
    super(props);

    // Load project options from local storage
    const ProjectOptions = reactLocalStorage.getObject(Constants.Model).project.options;

    this.state = {
      projectData: [], // Data received from the API
      ProjectOptions,  // Predefined project options
      projectSums:{},
    };
  }

  componentDidMount() {
    // Fetch data from the API
    IndividualSalesReportAPI.getIndividualMeetingByProject(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    const projectSums = {};
    this.state.ProjectOptions.forEach(option => {
      projectSums[option.value] = 0;
    });
    // Fill in the actual values from the API data
    data.forEach(item => {
      const project =  Boolean(item.project) ? [item.project] || item.project?.split('~').filter(Boolean) : null ;
      project?.forEach(pr => {
        projectSums[parseInt(pr)] += item.sum;
      })
    });
    this.setState({ projectSums: projectSums });
  };

  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const { projectSums, ProjectOptions } = this.state;
    // Calculate the total sum of all project values
    const totalSum = Object.values(projectSums).filter(Boolean).reduce((total, value) => total + value, 0);

    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>Site Visit By project Report</h2>
          <hr />
          <div className="row mt-3">
          <Table striped bordered hover className="col-md-6">
            <thead>
              <tr>
                <th>Site Visit</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {ProjectOptions.map((option, index) => (
                <tr key={index}>
                  <td>{option.label}</td>
                  <td>{projectSums[option.value]}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            {/* Add Chart Component */}
            <ChartComponent progressSums={projectSums} progressOptions={ProjectOptions} type="bar" />
          </div>
        </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(IndividualMeetingByProject);
